import type { PartnerTheme } from "../types";

export const PARTNER_THEMES: PartnerTheme[] = [
  { theme: "wayflyer", partnerId: "HbLL6T282akhR4gopGWLu1wU61Dk4Wg6" },
  { theme: "whiteLabel", partnerId: "VhNza7TvrW5CeqvfIuQMpFEmfRTclVYJ" },
];
